// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_x_Q","cls2":"BulkFollowPreview-cls2_HsR BulkFollowPreview-cls1_x_Q"};